import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Budget  {
    _originalTypeClassName = "zERP.BO.Budget";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Budget.translate = translateService;
}
this.Details = [];
this.Modifications = [];
this.Entity = new Domain.BusinessEntity();
this.Id = null;
this.Name = null;
this.Description = null;
this.SerialNumber = null;
this.RevisionNo = null;
this.DateCreated = null;
this.DateSubmited = null;
this.DateApproved = null;
this.SystemDateApproved = null;
this.Status = null;
this.ExpensesInitialAmount = 0;
this.RevenueInitialAmount = 0;
this.ExpensesTempAmount = 0;
this.RevenueTempAmount = 0;
this.ExpensesTotalAmount = 0;
this.RevenueTotalAmount = 0;
this.ExpensesAmountLastYear = 0;
this.ExpensesAmount2YearBefore = 0;
this.RevenueAmountLastYear = 0;
this.RevenueAmount2YearBefore = 0;
this.ApprovalReference = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
SerialNumber:any;
RevisionNo:any;
DateCreated:any;
DateSubmited:any;
DateApproved:any;
SystemDateApproved:any;
Status:any;
ExpensesInitialAmount:any;
RevenueInitialAmount:any;
ExpensesTempAmount:any;
RevenueTempAmount:any;
ExpensesTotalAmount:any;
RevenueTotalAmount:any;
ExpensesAmountLastYear:any;
ExpensesAmount2YearBefore:any;
RevenueAmountLastYear:any;
RevenueAmount2YearBefore:any;
ApprovalReference:any;
Details:any;
CreatedBy:any;
SubmittedBy:any;
ApprovedBy:any;
Modifications:any;
Entity:any;
FiscalYear:any;
static setDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.Details == null) $this.Details = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Details.length > 0) {
                    Domain.Budget.removeDetails($this, $this.Details[0]);
                }

                Domain.Budget.addManyDetails($this, copyItems);
            }
static addManyDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Budget.addDetails($this, items[i]);
                }
            }
static addDetails = ($this, item) => {
                if ($this.Details == null) $this.Details = [];
                if (item == null || $this.Details.indexOf(item) > -1) return;
                $this.Details.push(item);
}
static addRangeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Budget.addDetails($this, item));
            }
static removeDetails = ($this, item) => {
                if ($this == null || $this.Details == null || $this.Details.indexOf(item) === -1) return;
                var _index = $this.Details.indexOf(item);
                $this.Details.splice(_index, 1);
}
static clearDetails = ($this) => { $this.Details = null; }
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setSubmittedBy = ($this, value) => {
var oldValue = $this.SubmittedBy;
$this.SubmittedBy = value;
if (value != null) {
}
}
static setApprovedBy = ($this, value) => {
var oldValue = $this.ApprovedBy;
$this.ApprovedBy = value;
if (value != null) {
}
}
static setModifications = ($this, items) => {
                if (items == null) items = [];
                if ($this.Modifications == null) $this.Modifications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Modifications.length > 0) {
                    Domain.Budget.removeModifications($this, $this.Modifications[0]);
                }

                Domain.Budget.addManyModifications($this, copyItems);
            }
static addManyModifications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Budget.addModifications($this, items[i]);
                }
            }
static addModifications = ($this, item) => {
                if ($this.Modifications == null) $this.Modifications = [];
                if (item == null || $this.Modifications.indexOf(item) > -1) return;
                $this.Modifications.push(item);
if (item.Budget != $this) {
Domain.BudgetAdjustment.setBudget(item, $this);
}
}
static addRangeModifications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Budget.addModifications($this, item));
            }
static removeModifications = ($this, item) => {
                if ($this == null || $this.Modifications == null || $this.Modifications.indexOf(item) === -1) return;
                var _index = $this.Modifications.indexOf(item);
                $this.Modifications.splice(_index, 1);
item.Budget = null;
}
static clearModifications = ($this) => { $this.Modifications = null; }
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setFiscalYear = ($this, value) => {
var oldValue = $this.FiscalYear;
$this.FiscalYear = value;
if (value != null) {
}
}

static GetCategories($this: any): any{let nodes = [];
let categories = $this?.Details?.linq?.select((d) => d?.BudgetItem?.Category)?.toArray()?.linq?.distinct()?.toArray();
for (let _icat = 0; _icat < (categories == null ? 0 : categories.length); _icat++) {let cat = categories[_icat];let node = new Domain.TreeNode();node.label = cat?.Name;node.key = cat?.Id;nodes?.add(node);}
return nodes;
}
static GetClassName(): any{return "Budget";
}
static GetPreviousYearsAmmounts($this: any): any{let previousYearsAmounts = [];
for (let _ibudgetDetail = 0; _ibudgetDetail < ($this?.Details == null ? 0 : $this?.Details.length); _ibudgetDetail++) {let budgetDetail = $this?.Details[_ibudgetDetail];let previousYearsAmount = new Domain.BudgetDetailPreviousYearsAmountsDTO();previousYearsAmount.Id = budgetDetail?.Id;previousYearsAmount.AmountLastYear = budgetDetail?.AmountLastYear;previousYearsAmount.Amount2YearBefore = budgetDetail?.Amount2YearBefore;previousYearsAmounts?.add(previousYearsAmount);}
return previousYearsAmounts;
}
static SubmitOnAccounting($this: any): any{}
static UpdateBudgetIds($this: any): any{for (let _iitem = 0; _iitem < ($this?.Details == null ? 0 : $this?.Details.length); _iitem++) {let item = $this?.Details[_iitem];item.BudgetId = $this?.Id;item.BudgetStatus = $this?.Status;}
}
static UpdateTotals($this: any): any{let expenses = 0;
let income = 0;
let expensesTemp = 0;
let incomeTemp = 0;
for (let _iitem = 0; _iitem < ($this?.Details == null ? 0 : $this?.Details.length); _iitem++) {let item = $this?.Details[_iitem];let ammount = ($this?.Status == Domain.BudgetStatus.Draft ? item?.InitialAmount : item?.InitialApprovedAmount);if (item?.IsExpense) {expenses = Joove.Common.safeNumber(expenses) + Joove.Common.safeNumber(ammount);expensesTemp = Joove.Common.safeNumber(expensesTemp) + Joove.Common.safeNumber(item?.TemporaryAmount);}else {income = Joove.Common.safeNumber(income) + Joove.Common.safeNumber(ammount);incomeTemp = Joove.Common.safeNumber(incomeTemp) + Joove.Common.safeNumber(item?.TemporaryAmount);}}
if ($this?.Status == Domain.BudgetStatus.Draft) {$this.ExpensesInitialAmount = expenses;$this.RevenueInitialAmount = income;$this.ExpensesTempAmount = expensesTemp;$this.RevenueTempAmount = incomeTemp;}else {$this.ExpensesTotalAmount = expenses;$this.RevenueTotalAmount = income;}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}